// import React from 'react';
// import '../styles/ServiceCategory.css';
// import { useNavigate } from 'react-router-dom';
//#endregion
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ServiceCategory.css';
import axios from '../axiosConfig';
import imgPrefix from '../imgConfig'; // 导入 imgConfig.js
import { useTranslation } from 'react-i18next';


const ServiceCategory = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  useEffect(() => {
    const currentLang = i18n.language || 'zh';
    axios.get(`/xiangmufenlei/list?lang=${currentLang}`)
      .then((response) => {
        console.log("fenlei", response);
        return setCategories(response.data.data.list)})
      // .then((data) => setCategories(data))
      .catch((error) => console.error('Error fetching categories:', error));
  }, [i18n.language]);
  // const categories = [
  //   { name: '保洁清洗', icon: '/assets/icons/clean.png' },
  //   { name: '上门维修', icon: '/assets/icons/repair.png' },
  //   { name: '家电清洗', icon: '/assets/icons/appliance.png' },
  //   { name: '按摩推拿', icon: '/assets/icons/massage.png' },
  //   { name: '更多服务', icon: '/assets/icons/more.png' },
  // ];
  // const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    // 向后端传中文分类名，避免泰文时匹配失败
    navigate(`/services/${encodeURIComponent(category.leixing)}`);
  };
  // const goToServiceList = (category) => {
  //   navigate(`/services/${category.id}`);
  // };
  return (
    <div>
      <div className="service-category">
        {categories.length&&categories.map((category) => (
          
          <div key={category.id} className="service-item-category" onClick={() => handleCategoryClick(category)}>
          <div className="service-icon">
            <img src={`${imgPrefix}/${category.tupian}`} alt={category.name} />
          </div>
          <div className="service-name">{category.leixing}</div>
        </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceCategory;
